import { render, staticRenderFns } from "./_tabManageGroup.vue?vue&type=template&id=37ed2022&scoped=true"
import script from "./_tabManageGroup.vue?vue&type=script&lang=js"
export * from "./_tabManageGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ed2022",
  null
  
)

export default component.exports